import { IconProps } from "../../utils/global-types/global-types";

const ChevronUpIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 14 14"
      fill="none"
      className={className ? className : "w-6 h-6"}
      {...rest}
    >
      <path
        d="M3.5 8.75L7 5.25L10.5 8.75"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ChevronUpIcon;
